export enum AccountTypeEnum {
  Cash = 'CASH',
  Margin = 'MARGIN',
  Dvp = 'DVP',
  Short = 'SHORT',
}
